(function (angular) {
	'use strict';
	
	angular.module('localStorageModule', [
		'BaseConfig'
	]);
})(window.angular);